module.exports = __webpack_public_path__ + "static/media/Grovyle_gaussian2.a08ac8ab.png";